import React from "react";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";

export const Layout = ({ children }) => (
  <div className="min-h-screen flex flex-col bg-kid-bg">
    <Navbar />
    <main className="flex-1">{children}</main>
    <Footer />
  </div>
);
